import { ArrowRight } from "lucide-react";
import { FinanceOnboardingCta } from "./FinanceOnboardingCta";

interface StepProps {
  onNext: () => void;
}

export const Step1Welcome = ({ onNext }: StepProps) => (
  <div className="w-full max-w-2xl bg-white shadow-xl rounded-[50px] p-8 md:p-12">
    <div className="mx-auto max-w-lg text-center">
      <h1 className="text-4xl font-bold mb-4">
        <span className="text-gray-900">Activa </span>
        <span className="text-fluxi">Fluxi Finance</span>
      </h1>
      <p className="text-base font-normal text-[#64748B] leading-7">
        Conecta tus ventas, pauta y costos para ver recaudo, utilidad y embudos rentables en un solo lugar.
      </p>
    </div>

    <div className="mt-8 flex justify-center">
      <FinanceOnboardingCta onClick={onNext}>
        Activar Fluxi Finance <ArrowRight className="h-5 w-5" />
      </FinanceOnboardingCta>
    </div>
  </div>
);
